var map = {
	"../winaija/local-draw/local-draw.module.ngfactory": [
		"./src/app/winaija/local-draw/local-draw.module.ngfactory.js",
		"winaija-local-draw-local-draw-module-ngfactory"
	],
	"./bundles/bundles.module.ngfactory": [
		"./src/app/bundles/bundles.module.ngfactory.js",
		"common",
		"bundles-bundles-module-ngfactory"
	],
	"./casino/casino.module.ngfactory": [
		"./src/app/casino/casino.module.ngfactory.js",
		"default~casino-casino-module-ngfactory~dashboard-dashboard-module-ngfactory~insta-games-insta-games-~009857ac",
		"common",
		"casino-casino-module-ngfactory"
	],
	"./dashboard/dashboard.module.ngfactory": [
		"./src/app/dashboard/dashboard.module.ngfactory.js",
		"default~casino-casino-module-ngfactory~dashboard-dashboard-module-ngfactory~insta-games-insta-games-~009857ac",
		"default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~lottery-lottery-mo~edf7f9fb",
		"default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~shared-contact-us-~73af7409",
		"default~dashboard-dashboard-module-ngfactory~shared-contact-us-contact-us-module-ngfactory",
		"common",
		"dashboard-dashboard-module-ngfactory"
	],
	"./help/bonus/bonus.module.ngfactory": [
		"./src/app/help/bonus/bonus.module.ngfactory.js",
		"help-bonus-bonus-module-ngfactory"
	],
	"./help/cookie-policy/cookie-policy.module.ngfactory": [
		"./src/app/help/cookie-policy/cookie-policy.module.ngfactory.js",
		"help-cookie-policy-cookie-policy-module-ngfactory"
	],
	"./help/exclusive-offer-terms/exclusive-offer-terms.module.ngfactory": [
		"./src/app/help/exclusive-offer-terms/exclusive-offer-terms.module.ngfactory.js",
		"help-exclusive-offer-terms-exclusive-offer-terms-module-ngfactory"
	],
	"./help/exclusive-offer-terms2/exclusive-offer-terms2.module.ngfactory": [
		"./src/app/help/exclusive-offer-terms2/exclusive-offer-terms2.module.ngfactory.js",
		"help-exclusive-offer-terms2-exclusive-offer-terms2-module-ngfactory"
	],
	"./help/fifteen-discount/fifteen-discount.module.ngfactory": [
		"./src/app/help/fifteen-discount/fifteen-discount.module.ngfactory.js",
		"help-fifteen-discount-fifteen-discount-module-ngfactory"
	],
	"./help/fifty-refund/fifty-refund.module.ngfactory": [
		"./src/app/help/fifty-refund/fifty-refund.module.ngfactory.js",
		"help-fifty-refund-fifty-refund-module-ngfactory"
	],
	"./help/first-ticket-free/first-ticket-free.module.ngfactory": [
		"./src/app/help/first-ticket-free/first-ticket-free.module.ngfactory.js",
		"help-first-ticket-free-first-ticket-free-module-ngfactory"
	],
	"./help/five-for-one/five-for-one.module.ngfactory": [
		"./src/app/help/five-for-one/five-for-one.module.ngfactory.js",
		"help-five-for-one-five-for-one-module-ngfactory"
	],
	"./help/five-for-two/five-for-two.module.ngfactory": [
		"./src/app/help/five-for-two/five-for-two.module.ngfactory.js",
		"help-five-for-two-five-for-two-module-ngfactory"
	],
	"./help/five-tickets-free/five-tickets-free.module.ngfactory": [
		"./src/app/help/five-tickets-free/five-tickets-free.module.ngfactory.js",
		"help-five-tickets-free-five-tickets-free-module-ngfactory"
	],
	"./help/four-for-one/four-for-one.module.ngfactory": [
		"./src/app/help/four-for-one/four-for-one.module.ngfactory.js",
		"help-four-for-one-four-for-one-module-ngfactory"
	],
	"./help/four-for-two/four-for-two.module.ngfactory": [
		"./src/app/help/four-for-two/four-for-two.module.ngfactory.js",
		"help-four-for-two-four-for-two-module-ngfactory"
	],
	"./help/gamerules/gamerules.module.ngfactory": [
		"./src/app/help/gamerules/gamerules.module.ngfactory.js",
		"help-gamerules-gamerules-module-ngfactory"
	],
	"./help/one-ticket-free/one-ticket-free.module.ngfactory": [
		"./src/app/help/one-ticket-free/one-ticket-free.module.ngfactory.js",
		"help-one-ticket-free-one-ticket-free-module-ngfactory"
	],
	"./help/privacy-notice/privacy-notice.module.ngfactory": [
		"./src/app/help/privacy-notice/privacy-notice.module.ngfactory.js",
		"help-privacy-notice-privacy-notice-module-ngfactory"
	],
	"./help/rgp/rgp.module.ngfactory": [
		"./src/app/help/rgp/rgp.module.ngfactory.js",
		"help-rgp-rgp-module-ngfactory"
	],
	"./help/safety/safety.module.ngfactory": [
		"./src/app/help/safety/safety.module.ngfactory.js",
		"help-safety-safety-module-ngfactory"
	],
	"./help/six-for-three/six-for-three.module.ngfactory": [
		"./src/app/help/six-for-three/six-for-three.module.ngfactory.js",
		"help-six-for-three-six-for-three-module-ngfactory"
	],
	"./help/ten-discount/ten-discount.module.ngfactory": [
		"./src/app/help/ten-discount/ten-discount.module.ngfactory.js",
		"help-ten-discount-ten-discount-module-ngfactory"
	],
	"./help/ten-for-five/ten-for-five.module.ngfactory": [
		"./src/app/help/ten-for-five/ten-for-five.module.ngfactory.js",
		"help-ten-for-five-ten-for-five-module-ngfactory"
	],
	"./help/terms/terms.module.ngfactory": [
		"./src/app/help/terms/terms.module.ngfactory.js",
		"help-terms-terms-module-ngfactory"
	],
	"./help/three-for-one/three-for-one.module.ngfactory": [
		"./src/app/help/three-for-one/three-for-one.module.ngfactory.js",
		"help-three-for-one-three-for-one-module-ngfactory"
	],
	"./help/twenty-discount/twenty-discount.module.ngfactory": [
		"./src/app/help/twenty-discount/twenty-discount.module.ngfactory.js",
		"help-twenty-discount-twenty-discount-module-ngfactory"
	],
	"./help/two-for-one/two-for-one.module.ngfactory": [
		"./src/app/help/two-for-one/two-for-one.module.ngfactory.js",
		"help-two-for-one-two-for-one-module-ngfactory"
	],
	"./help/two-tickets-free/two-tickets-free.module.ngfactory": [
		"./src/app/help/two-tickets-free/two-tickets-free.module.ngfactory.js",
		"help-two-tickets-free-two-tickets-free-module-ngfactory"
	],
	"./help/wild-chase-tour/wild-chase-tour.module.ngfactory": [
		"./src/app/help/wild-chase-tour/wild-chase-tour.module.ngfactory.js",
		"help-wild-chase-tour-wild-chase-tour-module-ngfactory"
	],
	"./insta-games/insta-games.module.ngfactory": [
		"./src/app/insta-games/insta-games.module.ngfactory.js",
		"default~casino-casino-module-ngfactory~dashboard-dashboard-module-ngfactory~insta-games-insta-games-~009857ac",
		"common",
		"insta-games-insta-games-module-ngfactory"
	],
	"./lotteries/lotteries.module.ngfactory": [
		"./src/app/lotteries/lotteries.module.ngfactory.js",
		"default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~lottery-lottery-mo~edf7f9fb",
		"default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~shared-contact-us-~73af7409",
		"common",
		"lotteries-lotteries-module-ngfactory"
	],
	"./lottery/lottery.module.ngfactory": [
		"./src/app/lottery/lottery.module.ngfactory.js",
		"default~lottery-lottery-module-ngfactory~shared-cart-cart-module-ngfactory~shared-faq-faq-module-ngf~6a85a35a",
		"default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~lottery-lottery-mo~edf7f9fb",
		"common",
		"lottery-lottery-module-ngfactory"
	],
	"./scratch/scratch.module.ngfactory": [
		"./src/app/scratch/scratch.module.ngfactory.js",
		"scratch-scratch-module-ngfactory"
	],
	"./shared/about-us/about-us.module.ngfactory": [
		"./src/app/shared/about-us/about-us.module.ngfactory.js",
		"shared-about-us-about-us-module-ngfactory"
	],
	"./shared/bonus-policy/bonus-policy.module.ngfactory": [
		"./src/app/shared/bonus-policy/bonus-policy.module.ngfactory.js",
		"shared-bonus-policy-bonus-policy-module-ngfactory"
	],
	"./shared/cart/cart.module.ngfactory": [
		"./src/app/shared/cart/cart.module.ngfactory.js",
		"default~lottery-lottery-module-ngfactory~shared-cart-cart-module-ngfactory~shared-faq-faq-module-ngf~6a85a35a",
		"common",
		"shared-cart-cart-module-ngfactory"
	],
	"./shared/contact-us/contact-us.module.ngfactory": [
		"./src/app/shared/contact-us/contact-us.module.ngfactory.js",
		"default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~shared-contact-us-~73af7409",
		"default~dashboard-dashboard-module-ngfactory~shared-contact-us-contact-us-module-ngfactory",
		"common",
		"shared-contact-us-contact-us-module-ngfactory"
	],
	"./shared/faq/faq.module.ngfactory": [
		"./src/app/shared/faq/faq.module.ngfactory.js",
		"default~lottery-lottery-module-ngfactory~shared-cart-cart-module-ngfactory~shared-faq-faq-module-ngf~6a85a35a",
		"common",
		"shared-faq-faq-module-ngfactory"
	],
	"./shared/page-maintenance-break/page-maintenance-break.module.ngfactory": [
		"./src/app/shared/page-maintenance-break/page-maintenance-break.module.ngfactory.js",
		"shared-page-maintenance-break-page-maintenance-break-module-ngfactory"
	],
	"./shared/page404/page404.module.ngfactory": [
		"./src/app/shared/page404/page404.module.ngfactory.js",
		"shared-page404-page404-module-ngfactory"
	],
	"./shared/teamplay100/teamplay100.module.ngfactory": [
		"./src/app/shared/teamplay100/teamplay100.module.ngfactory.js",
		"shared-teamplay100-teamplay100-module-ngfactory"
	],
	"./shared/teamplay200/teamplay200.module.ngfactory": [
		"./src/app/shared/teamplay200/teamplay200.module.ngfactory.js",
		"shared-teamplay200-teamplay200-module-ngfactory"
	],
	"./shared/unsubscribe/unsubscribe.module.ngfactory": [
		"./src/app/shared/unsubscribe/unsubscribe.module.ngfactory.js",
		"shared-unsubscribe-unsubscribe-module-ngfactory"
	],
	"./shared/wagering-table/wagering-table.module.ngfactory": [
		"./src/app/shared/wagering-table/wagering-table.module.ngfactory.js",
		"shared-wagering-table-wagering-table-module-ngfactory"
	],
	"./sports-bet/sports-bet.module.ngfactory": [
		"./src/app/sports-bet/sports-bet.module.ngfactory.js",
		"sports-bet-sports-bet-module-ngfactory"
	],
	"./winaija/local-draw/local-draw.module.ngfactory": [
		"./src/app/winaija/local-draw/local-draw.module.ngfactory.js",
		"winaija-local-draw-local-draw-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;